import { useLanguage } from '@/i18n/LanguageContext';
import { Globe } from 'lucide-react';

const languages = [
  { code: 'it', label: 'IT', flag: '🇮🇹' },
  { code: 'en', label: 'EN', flag: '🇬🇧' },
  { code: 'es', label: 'ES', flag: '🇪🇸' }
];

export const LanguageSelector = () => {
  const { language, changeLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-1 bg-stone-100 rounded-full p-1" data-testid="language-selector">
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => changeLanguage(lang.code)}
          className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
            language === lang.code
              ? 'bg-[#2c4c3b] text-stone-50'
              : 'text-stone-600 hover:text-[#2c4c3b]'
          }`}
          data-testid={`lang-${lang.code}`}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;
